export default __webpack_public_path__ + "static/media/tw-white.e89575eb.svg";